import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { take } from 'rxjs/operators';


dayjs.extend(customParseFormat);
@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'dayjsFormat',
    pure: false
})
export class DayjsFormatPipe implements PipeTransform {
  private languageService = inject(LanguageService);
  private activeLocale = 'en';
  private initialized = false;

  constructor() {
    this.languageService.getActive().pipe(take(1)).subscribe((lang) => {
      this.activeLocale = lang === 'ja' ? 'ja' : 'en';
    });
  }

  transform(value: string | Date | null, inputFormat?: string, showTime: boolean = false): string {
    if (!value) return '';

    if (!this.initialized) {
      dayjs.locale(this.activeLocale);
      this.initialized = true;
    }

    let parsedDate: dayjs.Dayjs;

    if (typeof value === 'string') {
      value = value.trim();
      if (inputFormat) {
        const maxLength = inputFormat.length;
        const trimmed = value.substring(0, maxLength);
        parsedDate = dayjs(trimmed, inputFormat, true);
      } else {
        parsedDate = dayjs(value);
      }
    } else {
      parsedDate = dayjs(value);
    }

    if (!parsedDate.isValid()) return '';

    const format = this.activeLocale === 'ja'
      ? (showTime ? 'YYYY年M月D日（dd）HH:mm' : 'YYYY年M月D日（dd）')
      : (showTime ? 'YYYY/MM/DD (ddd) HH:mm' : 'YYYY/MM/DD (ddd)');

    return parsedDate.format(format);
  }
}
